import { Modal } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";

/**
 * Hook to show a delete confirmation modal
 * @param {Function} onConfirm - Function to execute on delete confirmation
 */
export default function useDeleteConfirm(onConfirm) {
  return (id, entities) => {
    return new Promise((resolve) => {
      Modal.confirm({
        title: "Are you sure you want to delete?",
        content: entities,
        okText: "Yes, Delete",
        cancelText: "Cancel",
        okType: "danger",
        icon: <ExclamationCircleFilled style={{ color: "#ff4d4f" }} />,
        onOk: async () => {
          try {
            await onConfirm(id); // Call the delete function
            resolve(); // ✅ Resolve after successful delete
          } catch (error) {
            resolve(); // ✅ Resolve instead of rejecting
          }
        },
        onCancel: () => resolve(), // ✅ Just resolve, don't reject
      });
    });
  };
}
